export const CREATE_CATEGORIE = "CREATE_CATEGORIE";
export const RETRIEVE_CATEGORIES = "RETRIEVE_CATEGORIES";
export const UPDATE_CATEGORIE = "UPDATE_CATEGORIE";
export const DELETE_CATEGORIE = "DELETE_CATEGORIE";
export const DELETE_ALL_CATEGORIES = "DELETE_ALL_CATEGORIES";